import { FC } from 'react'
import { useWindowSize } from 'react-use'
import {
    getStyledSecionHolder,
    getStyledSectionWrapper
} from '../../styled-components/SectionWrapper.styled'
import { MD_SCREEN } from '../../util/screen-size'
import { AboutSection } from '../about-section/AboutSection.component'
import { ContactSection } from '../ContactSection.component'
import { FeaturesSection } from '../products-section/FeaturesSection.component'
import { HomeSection } from '../home-section/HomeSection.component'
import { refTypes } from '../navbar/NavBar.component'

export interface SectionHolderProps {
    refList: refTypes
}

export const SectionHolder: FC<SectionHolderProps> = ({ refList }) => {

    const { width } = useWindowSize();
    const size = width > MD_SCREEN

    const SectionHolder = getStyledSecionHolder(size)
    const StyledSectionWrapper = getStyledSectionWrapper()


    return (
        <SectionHolder >
            <HomeSection refItem={refList.home} />
            <AboutSection refItem={refList.about} />
            <FeaturesSection refItem={refList.feature} />

            <StyledSectionWrapper ref={refList.contact}>
                <ContactSection />
            </StyledSectionWrapper>
        </SectionHolder>
    )
}